import { messages } from "../lib/messages";

/**
 * LoadingScreen — скелетон, не спиннер, пока идёт бутстрап (docs/07-miniapp-ux.md §2.1).
 */
export function LoadingScreen() {
  return (
    <div data-testid="shop-loading" aria-busy="true" aria-live="polite" className="min-h-screen bg-bg p-4">
      <span className="sr-only">{messages.loading}</span>
      <div className="mx-auto flex max-w-md flex-col gap-4">
        <div className="h-6 w-40 animate-pulse rounded-card bg-surface" />
        <div className="grid grid-cols-2 gap-3">
          <div className="h-40 animate-pulse rounded-card bg-surface" />
          <div className="h-40 animate-pulse rounded-card bg-surface" />
        </div>
      </div>
    </div>
  );
}
